import React from 'react'
import"./Phase1.css"
const Phase1 = () => {
  return (
    <div className='phase1box'>
        <h1 className="phase1head"style={{ textAlign: "center" }}>Offered services</h1>
        <p className="phase1para"style={{ textAlign: "center" }}>Web design and development have been my bread and butter for more than 5 years. During that time I've discovered that I can help startups and companies with the following services</p>
    </div>
  )
}

export default Phase1